const HOW_WE_RECOMMEND_FUNDS = {
  landingHeader: {
    dataAid: "howWeRecommend",
    title: {
      text: "How we recommend?",
    },
    subTitle: {
      text: "We have a robust & tested research methodology to recommend the best set of funds to you",
    },
  },
  stepsDetail: {
    text: "We take into account",
    dataAid: "title",
  },
  stepsContent: {
    titleDataAid: "title",
    iconDataAid: "left",
  },
  cta: {
    text: "OKAY",
    dataAid: "primary",
  },
};

export default HOW_WE_RECOMMEND_FUNDS;
